<template>
  <FlexRow align="center">
    <Label text="今月の無償スカウト残数" bold style="color: #888" class="text-center" />
    <Label :text="tickets.free" size="h6" bold />
    
    <Label text="今月の有償スカウト残数" bold style="color: #888;" class="text-center ml-2" />
    <Label :text="tickets.paid" size="h6" bold />
  </FlexRow>
</template>

<script>
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";

export default {
  name: "RequestTickets",
  components: {Label, FlexRow},
  computed: {
    ...mapGetters('chatRequests', ['tickets'])
  }
}
</script>
